import React from 'react';

const AddToWidgetTable = ({ title, rows, testId, disabled }) => (
  <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
    <table className="table table-striped table-bordered-outside" style={{ marginTop: '10px' }}>
      <tbody>
        <tr>
          <th colSpan="2">
            <div className="float-left">{title}</div>
          </th>
        </tr>
        {rows.map((row) => (
          <tr key={row.id} data-testid={testId}>
            <td>
              <strong>{row.title}</strong>
              {row.details}
            </td>
            <td>
              <div className="float-right" style={{ whiteSpace: 'nowrap' }}>
                <button type="button" className="btn btn-link" style={{ padding: 0 }} onClick={row.onAdd} disabled={disabled}>
                  <i className="fa fa-plus-square-o" aria-hidden="true"></i>{' '}
                  {t('quote_builder_widget.select_for_widget')}
                </button>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default AddToWidgetTable;
